import {InjectionToken} from '@angular/core';
import {ValidationRule} from './rules/rules';

export type IValidationConfiguration = {
    [context: string]: {
        [field: string]: ValidationRule[],
    },
};
export const VALIDATION_CONFIGURATION = new InjectionToken<IValidationConfiguration>('VALIDATION_CONFIGURATION');
